import React from 'react'
import PropTypes from 'prop-types'
import {copyToClipboard, nativeShareAvailable} from '../utils/share_utils'
import {isMobileSurface} from '../utils/device_utils'
import { componentText } from '../utils/i18n_utils'

const shareLabel = () => componentText('share_button.share', 'Share')

const ShareIcon = () => <i className="fa-regular fa-share" aria-hidden="true"/>

// Renders the orange Share icon button shown in the leaderboard header.
// On laptops/desktops it copies the page link and confirms with a toast, on
// phones it opens the device's native share sheet when available.
//
// The branch keys off the device, not viewMode: viewMode is width-only, so a
// narrowed laptop window reports 'landscape', and desktop browsers do expose
// navigator.share — web is meant to copy the link.
const ShareButton = ({leagueName, showLinkCopied, showLinkCopyFailed}) => {
  const copyLink = (url) =>
    copyToClipboard(url)
      .then(() => showLinkCopied())
      .catch(() => showLinkCopyFailed())

  const handleShare = () => {
    const url = window.location.href

    if (isMobileSurface() && nativeShareAvailable()) {
      // AbortError is the user closing the share sheet - not a failure. A
      // sheet that cannot open at all degrades to copying the link.
      navigator.share({title: leagueName, url}).catch((error) => {
        if (error && error.name === 'AbortError') {
          return
        }
        copyLink(url)
      })
      return
    }

    copyLink(url)
  }

  return (
    <button
      type="button"
      className="lbv2__share-btn themed-text"
      aria-label={shareLabel()}
      onClick={handleShare}>
      <ShareIcon/>
    </button>
  )
}

ShareButton.propTypes = {
  leagueName: PropTypes.string,
  showLinkCopied: PropTypes.func.isRequired,
  showLinkCopyFailed: PropTypes.func.isRequired,
}

export default ShareButton
